import React, { ImgHTMLAttributes } from "react";
import deepEquals from "fast-deep-equal/es6";
type Props = {
	urls: string[];
	alt?: string;
	className?: string;
	onLoad?: () => void;
} & Partial<ImgHTMLAttributes<HTMLImageElement>>;

export class ImageWithFallbacks extends React.Component<
	Props,
	{
		currentUrls: string[];
	}
> {
	constructor(props: Props) {
		super(props);
		this.state = {
			currentUrls: [...new Set(props.urls)]
		};
	}

	componentWillReceiveProps(newProps: Props) {
		if (!deepEquals(newProps.urls, this.props.urls)) {
			this.setState({
				currentUrls: [...new Set(newProps.urls)]
			});
		}
	}

	loadNext() {
		if (this.state.currentUrls.length < 1) {
			return;
		}

		this.setState((prevState) => ({
			currentUrls: prevState.currentUrls.slice(1)
		}));
	}

	render() {
		const { alt, urls, ...rest } = this.props;
		return <img src={this.state.currentUrls[0]} onError={this.loadNext.bind(this)} alt={alt} {...rest} />;
	}
}
